'use client';

import { createContext, useContext } from 'react';

import { User } from './utils/types';

const UserContext = createContext<User | undefined>(undefined);

export const useUser = () => useContext(UserContext);

interface UserProviderProps {
	user: User | undefined;
	children: React.ReactNode;
}

export const UserProvider = ({ user, children }: UserProviderProps) => {
	return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
